"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BUFFER_TIME_TYPES_OPTIONS = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));

var _reactUse = require("react-use");

var _personalProfileSettings = require("../../store/personalProfileSettings/personalProfileSettings.contants");

var _personalProfileSettings2 = require("../../store/personalProfileSettings");

var BUFFER_TIME_TYPES_OPTIONS = [{
  id: _personalProfileSettings2.BufferTimeType.hours,
  name: 'Hours'
}, {
  id: _personalProfileSettings2.BufferTimeType.days,
  name: 'Days'
}];
exports.BUFFER_TIME_TYPES_OPTIONS = BUFFER_TIME_TYPES_OPTIONS;

var BufferTimeItem = function BufferTimeItem(_ref) {
  var onUpdate = _ref.onUpdate,
      isLoading = _ref.isLoading,
      bufferTimeInMinutes = _ref.bufferTimeInMinutes,
      errors = _ref.errors;
  var isMount = (0, _react.useRef)(false);
  var isFullHours = bufferTimeInMinutes % _personalProfileSettings.minutesInDay === 0;

  var _useState = (0, _react.useState)(function () {
    return isFullHours ? _personalProfileSettings2.BufferTimeType.days : _personalProfileSettings2.BufferTimeType.hours;
  }),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      bufferType = _useState2[0],
      setBufferType = _useState2[1];

  var _useState3 = (0, _react.useState)(function () {
    return isFullHours ? bufferTimeInMinutes / _personalProfileSettings.minutesInDay : bufferTimeInMinutes / _personalProfileSettings.minutesInHour;
  }),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      bufferValue = _useState4[0],
      setBufferValue = _useState4[1];

  var handleUpdateBufferValue = (0, _react.useCallback)(function (_ref2) {
    var floatValue = _ref2.floatValue;
    setBufferValue(floatValue);
  }, [setBufferValue]);
  var handleUpdateBufferType = (0, _react.useCallback)(function (_ref3) {
    var bufferValueType = _ref3.bufferValueType;
    setBufferType(bufferValueType);
  }, [setBufferType]);
  (0, _reactUse.useDebounce)(function () {
    if (isMount.current) {
      onUpdate(bufferType === _personalProfileSettings2.BufferTimeType.days ? bufferValue * _personalProfileSettings.minutesInDay : bufferValue * _personalProfileSettings.minutesInHour);
    }
  }, 300, [bufferType, bufferValue]);
  (0, _reactUse.useMount)(function () {
    isMount.current = true;
  });
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1,
    ml: 3,
    mr: 3
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Label-Table-Left-Static"
  }, "MINIMUM NOTICE TIME"), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-Static"
  }, "This is the minimum amount of time that it needs to be from now (the moment somebody is trying to book you) before somebody can book the next meeting with you."), /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1,
    display: "flex",
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1 / 2,
    mr: 3,
    display: "flex",
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1 / 2,
    mr: 3,
    mt: 2
  }, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    fullWidth: true,
    onValueChange: handleUpdateBufferValue,
    decimalScale: 0,
    allowNegative: false,
    customInput: _material.TextField,
    thousandSeparator: true,
    value: bufferValue,
    variant: "outlined",
    label: "Invitees can`t schedule within...",
    disabled: isLoading,
    name: "bufferValue",
    inputProps: {
      'data-testid': 'MeetingSettings.BufferTime.BufferValue'
    }
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1 / 2
  }, /*#__PURE__*/_react.default.createElement(_ui.SelectFilter, {
    fullWidth: true,
    margin: "normal",
    onFilterChange: handleUpdateBufferType,
    renderItems: function renderItems() {
      return BUFFER_TIME_TYPES_OPTIONS.map(function (value_type) {
        return /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
          key: value_type.id,
          value: value_type.id
        }, value_type.name);
      });
    },
    name: "bufferValueType",
    disabled: isLoading,
    value: bufferType,
    label: "",
    dataTestId: "MeetingSettings.BufferTime.BufferType"
  }))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1 / 2
  })), errors && /*#__PURE__*/_react.default.createElement(_material.FormControl, {
    variant: "outlined",
    fullWidth: true,
    error: true
  }, /*#__PURE__*/_react.default.createElement(_material.FormHelperText, null, errors[0])), /*#__PURE__*/_react.default.createElement(_ui.Divider, {
    mt: 2,
    mb: 2
  })));
};

var _default = /*#__PURE__*/(0, _react.memo)(BufferTimeItem);

exports.default = _default;